import Vue from 'vue';
import Vuex from 'vuex';
// 单个模块的
import login from './modules/login';
// 全局共用
import state from './asset/state';
import getters from './asset/getters';
import mutations from './asset/mutations';
import actions from './asset/actions';
// 注册vuex
Vue.use(Vuex);
// 实例化vuex
const store = new Vuex.Store({
  state,
  getters,
  mutations,
  actions,
  modules: {
    login
  }
});
// 抛出
export default store;



// WEBPACK FOOTER //
// ./src/store/store.js